
import React from 'react';
import { TrackDownload } from '@/lib/types';
import { CardHeader } from '@/components/ui/card';
import { Collapsible, CollapsibleContent } from '@/components/ui/collapsible';
import ViewMode from './ViewMode';
import EditMode from './EditMode';
import TrackCardTitle from './TrackCardTitle';

interface DesktopLayoutProps {
  track: TrackDownload;
  onCopyUrl: (id: string) => void;
  onDeleteClick: (id: string) => void;
  isEditing: boolean;
  isEditOpen: boolean;
  setIsEditOpen: (open: boolean) => void;
  editProps: {
    spotifyUrl: string;
    isUrlValid: boolean;
    isSaving: boolean;
    currentFileName: string | null;
    trackTitle: string;
    description: string;
    onSpotifyUrlChange: (url: string) => void;
    onFileChange: (file: File | null) => void;
    onTitleChange: (title: string) => void;
    onDescriptionChange: (description: string) => void;
    onSaveEdit: () => Promise<void>;
    onCancelEdit: () => void;
    editFile: File | null;
  };
  formatDate: (dateString: string) => string;
  handleEditClick: () => void;
}

const DesktopLayout: React.FC<DesktopLayoutProps> = ({
  track,
  onCopyUrl,
  onDeleteClick,
  isEditing,
  isEditOpen,
  setIsEditOpen,
  editProps,
  formatDate,
  handleEditClick
}) => {
  return (
    <CardHeader className="py-4">
      <div className="flex items-center">
        <div className="flex-grow overflow-hidden">
          <TrackCardTitle 
            trackName={track.trackName} 
            fileName={track.fileName} 
          />
        </div>
        
        <div className="ml-6 flex-shrink-0">
          <ViewMode 
            track={track}
            onCopyUrl={onCopyUrl}
            onEditClick={handleEditClick}
            onDeleteClick={onDeleteClick}
            formatDate={formatDate}
            isEditing={isEditing}
          />
        </div>
      </div>
      
      <Collapsible 
        open={isEditOpen} 
        onOpenChange={setIsEditOpen} 
        className="mt-4 border border-border/40 rounded-md overflow-hidden"
      >
        <CollapsibleContent className="p-4 bg-secondary/30 animate-accordion-down">
          <EditMode 
            spotifyUrl={editProps.spotifyUrl}
            isUrlValid={editProps.isUrlValid}
            isSaving={editProps.isSaving}
            currentFileName={editProps.currentFileName}
            trackTitle={editProps.trackTitle}
            description={editProps.description}
            onSpotifyUrlChange={editProps.onSpotifyUrlChange}
            onFileChange={editProps.onFileChange}
            onTitleChange={editProps.onTitleChange}
            onDescriptionChange={editProps.onDescriptionChange}
            onSaveEdit={editProps.onSaveEdit}
            onCancelEdit={editProps.onCancelEdit}
            editFile={editProps.editFile}
          />
        </CollapsibleContent>
      </Collapsible>
    </CardHeader>
  );
};

export default DesktopLayout;
